export default function matcher(
	rxPattern: string,
	testString: string
): boolean {
	const regex = new RegExp(rxPattern.split("").join(".*"), "i");
	return regex.test(testString);
}
